import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectSOinfo, selectSOlistReg, selectSONOinfolist } from '../../Selectors/Master/ItemSelectors';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchSOinfolist, fetchSOnoInfolist, fetchSORegister } from '../../../Store/PHPSlice/Sale/SaleOrder';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';


const SOSampleInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        partyNm: '',
        adrs: '',
        contact: '',
        quotNo: '',
        itemNm: '',
        mulItem: [],
        gst: '',
        sono: '',
        orderno: '',
        remark: '',
        schlNm: '',
        size: [],
        rate: [],
        qty: [],
        totQty: '',

        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        maincloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        mstk: '',
        m1stk: '',
        m2stk: '',
        m3stk: '',
        firmId: '',
        sampleorderno: '',
        saleprice: '',
        itemhsn: '',
        firmNm: '',
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const soinfolist = useSelector(selectSONOinfolist);
    // console.log(soinfolist);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchSOnoInfolist(Id));
    }, [Id, dispatch]);
    useEffect(() => {

        if (soinfolist.data && soinfolist.data.length > 0) {
            const item = soinfolist.data[0];
            const mulitems = soinfolist.data.map(val => val.ID);
            setFormData(prev => ({
                ...prev,
                dt: item.ordt || '',
                quotNo: item.quotNo || '',
                sono: item.sono || '',
                firmNm: item.firmNm || '',
                itemhsn: item.itemhsn || '',
                sampleorderno: item.sampleorderno || '',
                saleprice: item.saleprice || '',
                orderno: item.orderno || '',
                partyNm: item.partyNm || '',
                schlNm: item.schoolNm || '',
                contact: item.contact || '',
                adrs: item.adrs || '',
                gst: item.gst || '',
                itemNm: item.itemNm || '',
                mclothNm: item.mclothNm || '',
                m1clothNm: item.m1clothNm || '',
                m2clothNm: item.m2clothNm || '',
                m3clothNm: item.m3clothNm || '',
                mulItem: mulitems,
                mstk: item?.mainClothStock,
                m1stk: item?.m1ClothStock,
                m2stk: item?.m2ClothStock,
                m3stk: item?.m3ClothStock,
                firmId: item?.firmId,

            }));
        }
    }, [soinfolist]);



    const tableContainerStyle = {
        marginLeft: isDesktop ? '2%' : '100%',
        width: isDesktop ? '95%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    function totalCalculation(formData) {
        if (formData.rate.length > 0 && formData.qty.length > 0) {
            const rateqty = formData.rate.length > 0 ? formData.rate.map((val, index) => {
                return (parseInt(val) * parseInt(formData.qty[index]));
            }) : '0'
            var sum = rateqty.reduce((sum, qty) => sum + qty, 0);
        }

        return sum;
    }
    const total = totalCalculation(formData);

    // ✅ ADD THIS BLOCK HERE
    let finalTaxable = 0;

    if (soinfolist?.data?.length > 0) {
        formData.mulItem.forEach(itemNm => {
            const itemData = soinfolist.infoData[itemNm]?.info_soId || [];

            itemData.forEach(val => {
                finalTaxable += (parseFloat(val.rate || 0) * parseFloat(val.qty || 0));
            });
        });
    }

    // GST logic
    const gstRate = finalTaxable <= 2500 ? 5 : 18;
    const isInterState = false;

    const cgst = isInterState ? 0 : (finalTaxable * (gstRate / 2)) / 100;
    const sgst = isInterState ? 0 : (finalTaxable * (gstRate / 2)) / 100;
    const igst = isInterState ? (finalTaxable * gstRate) / 100 : 0;

    const totalGST = isInterState ? igst : (cgst + sgst);
    const grandTotal = finalTaxable + totalGST;

    // console
    console.log('formData.mulItem.length', soinfolist);


    const terms = [
        { id: '1', label: 'The garment samples will be produce against the counter samples from buyer/client and accordingly the rates will be given.' },
        { id: '2', label: 'In Case of any changes & Addition in pattern from buyer, regarding fabric quality or pattern or Accessories or Size chart the given price list may revised.' },
        { id: '3', label: 'Fabric Availability- Will be decided as per the quality &quantity. Available fabric can be held for 5 working days, buyer has to confirm order to ensure the fabric availability.' },
        { id: '4', label: 'At the time of bulk order buyer must inform regarding the refill order confirmation against the bulk order, so that the fabrics can be reserved against the refill order and carry the stock for timely delivery of garment quantity.' },
        { id: '5', label: 'Garment Delivery schedule will be given once the order is confirmed & on the fulfillment of the payment term applicable.' },
        { id: '6', label: 'The Minimum order qty of single style will be 200 pieces (per Size minimum qty will be 20 pieces).' },
        { id: '7', label: 'In case the order quantity is below 200 pieces additional rate of 15% will be chargeable.' },
        { id: '8', label: 'The actual delivery quantity of all the order will be +/- 5% from the order quantity. No return of this + 5% is accepted. If required will be treated as new order & new d delivery period / Subject to -5% Qty is above 100Pcs.' },
    ];

    const payment = [
        { id: '1', label: 'Any order below 2 Lac will be on 100% advance payment.' },
        { id: '2', label: 'Between 2 Lac and 10 lakhs will be 50% Advance and balance PDC of 30 days.' },
        { id: '3', label: 'Above 10 Lac will be 25% Advance and balance PDC of 45 days.' },
        { id: '4', label: 'Orders which are of higher value than 20 lakhs will be taken on case-to-case basis.' },
        { id: '5', label: 'In case for maintaining fabric stock, against specific order, Separate SO will be generated against extra fabric stock and50% of that SO amount will be taken as deposit.' },
        { id: '6', label: 'In case of raise in Fabric rates, new rates will be applicable on spillover orders of all old orders.' },
    ];

    const returnReplacement = [
        { id: '1', label: 'Goods once sold cannot be returned unless verified &genuine complaint regardinggarment.' },
        { id: '2', label: 'Material must be returned within 30 Days from the date of receipt. After that no complain will be entertained.' },
        { id: '3', label: 'Lorry Receipt of all Return Goods Should be booked at Solapur factory after approval of concern marketing person, if the goods are booked by the buyer without approval the goods will not beaccepted.' },
    ];

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData?.firmId} />}
                        <h3 className='centered-heading'>Sample Sale Order Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>

                                <tr>
                                    <td style={{ width: '200px' }}>Party Name</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.partyNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Sale Order No.</td>
                                    <td>:</td>
                                    <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.sono}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Sample Order No</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.sampleorderno}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Sample Price</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.saleprice}</td>
                                </tr>



                                <tr>
                                    <td style={{ width: '200px' }}>Address</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.adrs}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Mobile No.</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.contact}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>GST No.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.gst}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>School Name</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.schlNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Remark</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.remark == "" ? '-' : formData.remark}</td>
                                </tr>

                            </tbody>

                        </table>


                        {
                            formData.mulItem.length > 0 &&
                            formData.mulItem.map((itemNm, index) => {

                                const totalValues = soinfolist.infoData[itemNm].info_soId.reduce(
                                    (totals, val) => {
                                        totals.totalRate += parseFloat(val.rate || 0); // Sum of rates
                                        totals.totalQty += parseFloat(val.qty || 0);   // Sum of quantities
                                        totals.totalAmount += parseFloat(val.rate || 0) * parseFloat(val.qty || 0); // Sum of amount (rate * qty)
                                        return totals;
                                    },
                                    { totalRate: 0, totalQty: 0, totalAmount: 0 } // Initial totals
                                );

                                const selectItem = soinfolist?.data?.find((item => item.ID === itemNm));
                                const par_item = selectItem.itemNm;
                                const itemhsnnm = selectItem.itemhsn;
                                const qtnodata = selectItem.quotNo;
                                const main_coth = selectItem?.maincloth !== '0' ? selectItem?.maincloth : '';
                                const m1_coth = selectItem?.m1cloth !== '0' ? selectItem?.m1cloth : '';
                                const m2_coth = selectItem?.m2cloth !== '0' ? selectItem?.m2cloth : '';
                                const m3_coth = selectItem?.m3cloth !== '0' ? selectItem?.m3cloth : '';

                                const stk = selectItem?.mainClothStock !== '0' ? selectItem?.mainClothStock : '0';
                                const stk1 = selectItem?.m1ClothStock !== '0' ? selectItem?.m1ClothStock : '0';
                                const stk2 = selectItem?.m2ClothStock !== '0' ? selectItem?.m2ClothStock : '0';
                                const stk3 = selectItem?.m3ClothStock !== '0' ? selectItem?.m3ClothStock : '0';

                                const reqData = soinfolist?.infoData[itemNm]?.info_soId?.[0] || {};

                                const mainReqMtr = reqData.mainReqMtr || 0;
                                const m1ReqMtr = reqData.m1ReqMtr || 0;
                                const m2ReqMtr = reqData.m2ReqMtr || 0;
                                const m3ReqMtr = reqData.m3ReqMtr || 0;

                                return (
                                    soinfolist.infoData[itemNm].info_soId.length > 0 && (

                                        // <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle, margin: '1% 5%', fontSize: '14px', width: '90%', display: 'flex' }} key={index}>
                                        //     <Table>
                                        //         <TableHead>
                                        //             <TableRow className="tbl-row">

                                        //             </TableRow>
                                        //             <TableRow className="tbl-row">
                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Quotation No</TableCell>

                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Particulars</TableCell>
                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">HSN Code</TableCell>

                                        //             </TableRow>
                                        //         </TableHead>

                                        //         <TableBody>
                                        //             <TableRow>
                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">{qtnodata}</TableCell>
                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">
                                        //                     {par_item} <br />
                                        //                     {/* {`cloth - ${main_coth}`} <br />
                                        //                     {`cloth1 - ${m1_coth}`} <br />
                                        //                     {`cloth2 - ${m2_coth}`} <br />
                                        //                     {`cloth3 - ${m3_coth}`} */}

                                        //                     {
                                        //                         [
                                        //                             { label: "Main Cloth", value: main_coth, stk: stk, req: mainReqMtr },
                                        //                             { label: "M1 Cloth", value: m1_coth, stk: stk1, req: m1ReqMtr },
                                        //                             { label: "M2 Cloth", value: m2_coth, stk: stk2, req: m2ReqMtr },
                                        //                             { label: "M3 Cloth", value: m3_coth, stk: stk3, req: m3ReqMtr },
                                        //                         ]
                                        //                             .filter(c => c.value && c.value !== "0") // remove empty, null, or '0'
                                        //                             .map((c, i) => (
                                        //                                 <div key={i}>{`${c.label} - ${c.value}`}
                                        //                                     <span className="no-print" style={{
                                        //                                         color: c.stk > 0 ? "green" : "red",
                                        //                                         fontWeight: "bold"
                                        //                                     }}>
                                        //                                         {`(Stock : ${c.stk})`}
                                        //                                     </span>

                                        //                                     <br />

                                        //                                     <span className="no-print" style={{
                                        //                                         color: "blue",
                                        //                                         fontWeight: "bold",
                                        //                                         marginLeft: "8px"
                                        //                                     }}>
                                        //                                         {`(Req : ${parseFloat(c.req).toFixed(2)} Mtr)`}
                                        //                                     </span>
                                        //                                 </div>
                                        //                             ))}
                                        //                 </TableCell>
                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">{itemhsnnm}</TableCell>

                                        //             </TableRow>
                                        //         </TableBody>
                                        //     </Table>


                                        //     <Table>
                                        //         <TableHead>
                                        //             <TableRow className="tbl-row">
                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Size</TableCell>
                                        //                 {soinfolist?.infoData[itemNm].info_soId.map((val, valIndex) => (
                                        //                     <TableCell key={valIndex} sx={{ p: 0.4, border: "1px solid #000" }} align="center">
                                        //                         {val.size}
                                        //                     </TableCell>
                                        //                 ))}

                                        //             </TableRow>
                                        //         </TableHead>

                                        //         <TableBody>
                                        //             <TableRow>
                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Rate</TableCell>
                                        //                 {soinfolist?.infoData[itemNm].info_soId.map((val, valIndex) => (
                                        //                     <TableCell key={valIndex} sx={{ p: 0.4, border: "1px solid #000" }} align="center">
                                        //                         {val.rate}
                                        //                     </TableCell>
                                        //                 ))}

                                        //             </TableRow>
                                        //             <TableRow>

                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Qty</TableCell>
                                        //                 {soinfolist?.infoData[itemNm].info_soId.map((val, valIndex) => (
                                        //                     <TableCell key={valIndex} sx={{ p: 0.4, border: "1px solid #000" }} align="center">
                                        //                         {val.qty}
                                        //                     </TableCell>
                                        //                 ))}

                                        //             </TableRow>
                                        //         </TableBody>

                                        //     </Table>


                                        //     <Table>
                                        //         <TableHead>
                                        //             <TableRow className="tbl-row">

                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Total Qty</TableCell>
                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">Total Amount</TableCell>
                                        //             </TableRow>
                                        //         </TableHead>

                                        //         <TableBody>
                                        //             <TableRow>

                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">
                                        //                     {totalValues.totalQty}
                                        //                 </TableCell>
                                        //                 <TableCell sx={{ p: 0.4, border: "1px solid #000", fontSize: "15px" }} align="center">
                                        //                     {totalValues.totalAmount.toFixed(2)}
                                        //                 </TableCell>
                                        //             </TableRow>




                                        //         </TableBody>
                                        //     </Table>


                                        // </TableContainer>
                                       <TableContainer
    style={{
        ...tableContainerStyle,
        ...webkitScrollbarStyle,
        margin: '1% 5%',
        width: '90%'
    }}
    key={index}
>
    <Table>
        <TableHead>
            <TableRow className="tbl-row">
                <TableCell sx={{ border: "1px solid #000" }} align="center">Quotation No</TableCell>
                <TableCell sx={{ border: "1px solid #000" }} align="center">Particulars</TableCell>
                <TableCell sx={{ border: "1px solid #000" }} align="center">HSN Code</TableCell>
                <TableCell sx={{ border: "1px solid #000" }} align="center">Size</TableCell>
                <TableCell sx={{ border: "1px solid #000" }} align="center">Rate</TableCell>
                <TableCell sx={{ border: "1px solid #000" }} align="center">Qty</TableCell>
                <TableCell sx={{ border: "1px solid #000" }} align="center">GST %</TableCell>
                <TableCell sx={{ border: "1px solid #000" }} align="center">Amount</TableCell>
            </TableRow>
        </TableHead>

        <TableBody>

            {(() => {
                let totalCGST = 0;
                let totalSGST = 0;
                let grandTotal = 0;
                let finalTaxableAmount = 0;

                return soinfolist?.infoData[itemNm].info_soId.map((val, valIndex) => {

                    const rate = parseFloat(val.rate || 0);
                    const qty = parseFloat(val.qty || 0);

                    const baseAmount = rate * qty;

                    // GST %
                    const gstPercent = rate <= 2500 ? 5 : 18;

                    // CGST / SGST
                    const cgstAmt = (baseAmount * (gstPercent / 2)) / 100;
                    const sgstAmt = (baseAmount * (gstPercent / 2)) / 100;

                    const totalAmount = baseAmount + cgstAmt + sgstAmt;

                    // TOTALS
                    totalCGST += cgstAmt;
                    totalSGST += sgstAmt;
                    grandTotal += totalAmount;
                    finalTaxableAmount += baseAmount;

                    return (
                        <TableRow key={valIndex}>

                            {/* ROWSPAN DATA */}
                            {valIndex === 0 && (
                                <>
                                    <TableCell
                                        rowSpan={soinfolist.infoData[itemNm].info_soId.length}
                                        sx={{ border: "1px solid #000" }}
                                        align="center"
                                    >
                                        {qtnodata}
                                    </TableCell>

                                    <TableCell
                                        rowSpan={soinfolist.infoData[itemNm].info_soId.length}
                                        sx={{ border: "1px solid #000" }}
                                        align="center"
                                    >
                                        {par_item}

                                        {
                                            [
                                                { label: "Main Cloth", value: main_coth, stk: stk, req: mainReqMtr },
                                                { label: "M1 Cloth", value: m1_coth, stk: stk1, req: m1ReqMtr },
                                                { label: "M2 Cloth", value: m2_coth, stk: stk2, req: m2ReqMtr },
                                                { label: "M3 Cloth", value: m3_coth, stk: stk3, req: m3ReqMtr },
                                            ]
                                                .filter(c => c.value && c.value !== "0")
                                                .map((c, i) => (
                                                    <div key={i}>
                                                        {`${c.label} - ${c.value}`}
                                                        <span
                                                            className="no-print"
                                                            style={{
                                                                color: c.stk > 0 ? "green" : "red",
                                                                fontWeight: "bold"
                                                            }}
                                                        >
                                                            {` (Stock : ${c.stk})`}
                                                        </span>

                                                        <br />

                                                        <span
                                                            className="no-print"
                                                            style={{
                                                                color: "blue",
                                                                fontWeight: "bold"
                                                            }}
                                                        >
                                                            {` (Req : ${parseFloat(c.req || 0).toFixed(2)} Mtr)`}
                                                        </span>
                                                    </div>
                                                ))
                                        }
                                    </TableCell>

                                    <TableCell
                                        rowSpan={soinfolist.infoData[itemNm].info_soId.length}
                                        sx={{ border: "1px solid #000" }}
                                        align="center"
                                    >
                                        {itemhsnnm}
                                    </TableCell>
                                </>
                            )}

                            {/* ROW DATA */}
                            <TableCell sx={{ border: "1px solid #000" }} align="center">
                                {val.size}
                            </TableCell>

                            <TableCell sx={{ border: "1px solid #000" }} align="center">
                                {rate}
                            </TableCell>

                            <TableCell sx={{ border: "1px solid #000" }} align="center">
                                {qty}
                            </TableCell>

                            <TableCell sx={{ border: "1px solid #000" }} align="center">
                                {gstPercent} %
                            </TableCell>

                            <TableCell sx={{ border: "1px solid #000" }} align="center">
                                {baseAmount.toFixed(2)}
                            </TableCell>
                        </TableRow>
                    );
                }).concat(

                    /* TOTAL ROW */
                    <TableRow key="total">
                        <TableCell colSpan={5}
                            sx={{ border: "1px solid #000", fontWeight: "bold" }}
                            align="right">
                            Total
                        </TableCell>

                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold" }} align="center">
                            {totalValues.totalQty}
                        </TableCell>

                        <TableCell sx={{ border: "1px solid #000" }}></TableCell>

                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold" }} align="center">
                            {finalTaxableAmount.toFixed(2)}
                        </TableCell>
                    </TableRow>,

                    /* CGST */
                    !isInterState && (
                        <TableRow key="cgst">
                            <TableCell colSpan={7} align="right" sx={{ border: "1px solid #000" }}>
                                CGST
                            </TableCell>
                            <TableCell align="center" sx={{ border: "1px solid #000" }}>
                                {totalCGST.toFixed(2)}
                            </TableCell>
                        </TableRow>
                    ),

                    /* SGST */
                    !isInterState && (
                        <TableRow key="sgst">
                            <TableCell colSpan={7} align="right" sx={{ border: "1px solid #000" }}>
                                SGST
                            </TableCell>
                            <TableCell align="center" sx={{ border: "1px solid #000" }}>
                                {totalSGST.toFixed(2)}
                            </TableCell>
                        </TableRow>
                    ),

                    /* IGST */
                    isInterState && (
                        <TableRow key="igst">
                            <TableCell colSpan={7} align="right" sx={{ border: "1px solid #000" }}>
                                IGST
                            </TableCell>
                            <TableCell align="center" sx={{ border: "1px solid #000" }}>
                                {(totalCGST + totalSGST).toFixed(2)}
                            </TableCell>
                        </TableRow>
                    ),

                    /* GRAND TOTAL */
                    <TableRow key="grand">
                        <TableCell colSpan={7}
                            sx={{ border: "1px solid #000", fontWeight: "bold", background: "#f5f5f5" }}
                            align="right">
                            Gross Amount
                        </TableCell>

                        <TableCell sx={{ border: "1px solid #000", fontWeight: "bold" }} align="center">
                            {grandTotal.toFixed(2)}
                        </TableCell>
                    </TableRow>
                );
            })()}

        </TableBody>
    </Table>
</TableContainer>
                                    )
                                );
                            })
                        }
                        
                     
                        {/* <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>ItemName</TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                        {formData.size.length > 0 ? formData.size.map((item, index) => (
                                            <TableCell key={index} sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item}</TableCell>
                                        )) : ''}
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Qty</TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.itemNm} <br />
                                            {formData.mclothNm !== '0' ? formData.mclothNm : ''} <br /> {formData.m1clothNm !== '0' ? formData.m1clothNm : ''}<br />
                                            {formData.m2clothNm !== '0' ? formData.m2clothNm : ''} <br /> {formData.m3clothNm !== '0' ? formData.m3clothNm : ''}</TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Rate(&#8377;)</TableCell>
                                        {formData.rate.length > 0 ? formData.rate.map((item, index) => (
                                            <TableCell key={index} sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item}</TableCell>
                                        )) : ''}
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Qty</TableCell>
                                        {formData.qty.length > 0 ? formData.qty.map((item, index) => (
                                            <TableCell key={index} sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item}</TableCell>
                                        )) : ''}
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.totQty}</TableCell>
                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>{total}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer> */}


                        <div style={{ marginTop: '3%', marginLeft: '5%' }}>
                            <h4 style={{ marginBottom: '8px', textDecoration: 'underline' }}>Terms & Conditions</h4>
                            <ol style={{ fontSize: '15px', lineHeight: '1.6' }}>
                                {terms?.map((item, index) => (
                                    <li key={item.id}>{item.label}</li>
                                ))}
                            </ol>
                        </div>

                        <div style={{ marginTop: '3%', marginLeft: '5%' }}>
                            <h4 style={{ marginBottom: '8px', textDecoration: 'underline' }}>Payment Terms</h4>
                            <ol style={{ fontSize: '15px', lineHeight: '1.6' }}>
                                {payment?.map((item, index) => (
                                    <li key={item.id}>{item.label}</li>
                                ))}
                            </ol>
                        </div>

                        <div style={{ marginTop: '3%', marginLeft: '5%' }}>
                            <h4 style={{ marginBottom: '8px', textDecoration: 'underline' }}>Return & Replacement</h4>
                            <ol style={{ fontSize: '15px', lineHeight: '1.6' }}>
                                {returnReplacement?.map((item, index) => (
                                    <li key={item.id}>{item.label}</li>
                                ))}
                            </ol>
                        </div>

                        <div style={{ float: 'right', marginRight: '10%', textAlign: 'center' }}>
                            <h4 style={{ marginBottom: '3rem' }}>Authorized By</h4>
                            <h6>{formData?.firmNm}</h6>
                        </div>


                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default SOSampleInfo;
